// SPDX-License-Identifier: MIT
import type { Session } from '@supabase/supabase-js';
import { supabase } from './supabase';

export async function getSession(): Promise<Session | null> {
  const { data, error } = await supabase.auth.getSession();
  if (error) {
    console.warn('[auth] getSession error:', error.message);
    return null;
  }
  return data.session ?? null;
}

export type SessionListener = (session: Session | null) => void;

export function observeSession(listener: SessionListener): () => void {
  const { data } = supabase.auth.onAuthStateChange((_event, session) => {
    listener(session ?? null);
  });
  return () => data.subscription.unsubscribe();
}

export async function signOut(): Promise<void> {
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
}
